import axios from 'axios';

// Arham Secure platform backend (arham-secure-server) — powers lead capture
// and the "Leads" section of the internal admin panel.
const LEADS_API_URL = process.env.REACT_APP_API_URL || 'https://uatapi.arhamsecure.com';

const leadsApi = axios.create({
    baseURL: LEADS_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const createLead = async (data) => {
    const response = await leadsApi.post('/api/leads', data);
    return response.data;
};

export const updateLeadDetails = async (leadId, data) => {
    const response = await leadsApi.patch(`/api/leads/${leadId}/details`, data);
    return response.data;
};

// Password-only gate for the /admin/leads page — re-checked on every call,
// no session persisted. See arham-secure-server's /api/leads/admin-view.
export const fetchLeadsAdminView = async (params) => {
    const response = await leadsApi.post('/api/leads/admin-view', params);
    return response.data;
};

// The old dedicated contacts service (`api` -> arhamsecurecorp-*.azurewebsites.net)
// is decommissioned. Contact Us submissions now go through the same leads
// pipeline as the rest of the site, tagged product_type "contact-enquiry" so
// they're distinguishable from insurance-quote leads in /admin/leads and the
// corporate panel.
export const createContact = async (data) => {
    try {
        const response = await leadsApi.post('/api/leads', {
            phone_number: data.phone,
            name: data.name,
            email: data.email,
            product_type: 'contact-enquiry',
            form_data: { subject: data.subject, message: data.message },
        });
        return { success: true, message: 'Thank you for contacting us. Our team will get back to you within 24 hours.', ...response.data };
    } catch (error) {
        console.error('Error creating contact:', error);
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            throw {
                message: error.response.data.message || 'Failed to submit contact form',
                errors: error.response.data.errors || [],
                status: error.response.status
            };
        } else if (error.request) {
            // The request was made but no response was received
            throw {
                message: 'No response from server. Please check your connection.',
                errors: []
            };
        } else {
            // Something happened in setting up the request that triggered an Error
            throw {
                message: error.message || 'Failed to submit contact form',
                errors: []
            };
        }
    }
};

export default {
    createContact,
    createLead,
    updateLeadDetails,
    fetchLeadsAdminView
};
